import { useState } from 'react';
import { Snackbar } from '@mui/material';
import Alert from 'domains/core/components/Alert';

type Props = {
    successMessage: string;
};

const SuccessSnackbar = ({ successMessage }: Props) => {
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
            <Alert onClose={handleClose} severity="success">
                {successMessage}
            </Alert>
        </Snackbar>
    );
};

export default SuccessSnackbar;
